import eventWaitlistService from './eventWaitlistService'
export default eventWaitlistService



// WEBPACK FOOTER //
// ../src/services/eventWaitlistService/index.js